
  <div class="verifyOTP">
    <h4>An OTP has been sent to your mobile via SMS.</h4>
    <div class="sendOTP">
      <form [formGroup]="OTPForm" *ngIf="IsInitialized">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <h5>OTP</h5>
              <input type="text" class="form-control" placeholder="Enter OTP" formControlName="OTP" />
              <span *ngIf="OTPForm.controls.OTP.errors">
                {{ErrorMessage}}
              </span>
            </div>
          </div>
        </div>
        <button class="cButtonSubmit" (click)="VerifyOTP()" *ngIf="!requestSent">Verify OTP</button>
        <span class="resendOTP" (click)="ResendOTP()" *ngIf="!requestSent">Click here to resend OTP</span>
        <button class="btn btn-primary" *ngIf="requestSent">
          <manik-button-loader></manik-button-loader>
        </button>
      </form>
      <manik-data-loader *ngIf="!IsInitialized"></manik-data-loader>
    </div>
  </div>

  
<!--Limited no of requests fto resend OTP. And do not allow continuous requests to resend OTP (disable based on time on client side).-->
